<template>
  <div class="blog">
    <section
      class="hero-blog"
      v-if="!this.empty"
      :style="{ 'background-image': 'url(' + heroImage + ')' }"
    >
      <div class="hero-mask"></div>
      <div
        class="container"
        v-for="item in this.mainPost"
        :value="item.id"
        :key="item.id"
      >
        <h1>{{ item.attributes.title }}</h1>
        <p>{{ item.attributes.description }}</p>
        <router-link
          :to="{
            name: 'BlogPost',
            params: { slug: item.attributes.slug }
          }"
          class="button-overlay"
        >
          Ler mais
        </router-link>
      </div>
    </section>
    <section class="blog-search" v-if="!this.empty">
      <div class="container">
        <!-- <div class="search">
          <img src="~@/assets/icons/icon-search.svg" alt="" />
          <input
            type="text"
            placeholder="Buscar notícias"
            v-model="searchText"
            @change="searchChange()"
          />
          <a @click="searchChange()" class="button-primary"
            ><img src="~@/assets/icons/icon-search-white.svg" alt=""
          /></a>
        </div> -->
      </div>
    </section>
    <section class="news" v-if="!this.empty">
      <div class="container">
        <h2><span>Últimas </span>Notícias</h2>
      </div>
      <div class="container container-news">
        <div
          class="box-news"
          v-for="item in this.lastPosts"
          :value="item.id"
          :key="item.id"
        >
          <router-link
            :to="{
              name: 'BlogPost',
              params: { slug: item.attributes.slug }
            }"
          >
            <img class="news-image" alt="" :src="item.attributes.banner_url" />
          </router-link>
          <router-link
            :to="{
              name: 'BlogPost',
              params: { slug: item.attributes.slug }
            }"
          >
            <h3>{{ item.attributes.title }}</h3>
          </router-link>
          <p>{{ item.attributes.description }}</p>
          <router-link
            class="button"
            :to="{
              name: 'BlogPost',
              params: { slug: item.attributes.slug }
            }"
          >
            Ler mais
          </router-link>
        </div>
      </div>
    </section>
    <div v-if="this.empty" class="empty">
      <img src="~@/assets/image-post-empty.svg" alt="" />
      <h3>Oops!</h3>
      <p>Ainda não temos nenhuma postagem, em breve teremos muito conteúdo.</p>
    </div>
    <section class="other-news" v-if="!this.empty && totalItems > 4">
      <div class="container">
        <h2><span>Outras </span>Notícias</h2>
      </div>
      <div class="container container-news">
        <div
          class="box-news"
          v-for="item in this.othersPosts"
          :value="item.id"
          :key="item.id"
        >
          <router-link
            :to="{
              name: 'BlogPost',
              params: { slug: item.attributes.slug }
            }"
          >
            <img class="news-image" alt="" :src="item.attributes.banner_url" />
          </router-link>
          <div class="news-content">
            <router-link
              :to="{
                name: 'BlogPost',
                params: { slug: item.attributes.slug }
              }"
            >
              <h3>{{ item.attributes.title }}</h3>
            </router-link>
            <p>{{ item.attributes.description }}</p>
            <router-link
              class="button"
              :to="{
                name: 'BlogPost',
                params: { slug: item.attributes.slug }
              }"
            >
              Ler mais
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <div class="view-more" v-if="renderViewMore">
      <a @click="viewMore()">Carregar mais</a>
    </div>
  </div>
</template>

<script>
import { blogService } from "@/services/blog.service";

export default {
  name: "Blog",

  data() {
    return {
      empty: false,
      mainPost: [],
      heroImage: "",
      lastPosts: [],
      searchText: "",
      othersPosts: [],
      currentPage: 1,
      perPage: 5,
      totalItems: 0,
      totalPages: 0
    };
  },

  computed: {
    renderViewMore() {
      return this.perPage < this.totalItems;
    }
  },

  mounted() {
    this.getPosts();
  },

  methods: {
    async getPosts() {
      try {
        const pagination = {
          items: this.perPage,
          page: this.currentPage
        };

        const posts = await blogService.listPosts(pagination);
        this.totalItems = posts.data.meta.count;
        this.totalPages = posts.data.meta.pages;
        this.currentPage = posts.data.meta.page;
        this.empty = posts.data.data.count === 0;
        this.mainPost = posts.data.data.slice(0, 1);
        this.heroImage = posts.data.data[0].attributes.banner_url;
        this.lastPosts = posts.data.data.slice(1, 4);
        this.othersPosts = posts.data.data.slice(4);
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    },

    searchChange() {
      this.$router.push(`/blog/pesquisar/${this.searchText}`);
    },

    viewMore() {
      if (this.perPage <= this.totalItems) {
        this.perPage = this.perPage + 5;
        this.getPosts();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  padding: 0 0 100px;
  margin-top: 64px;

  .container {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    align-items: flex-start;

    &.container-news {
      max-width: 1200px;
      margin-top: 62px;
    }
  }

  .view-more {
    margin: 60px 0 0;
    text-align: center;

    a {
      outline: none;
      text-decoration: none;
      font-weight: var(--weight-bold);
      color: var(--blue-custom);
      cursor: pointer;
    }

    a:hover,
    a:active,
    a:focus {
      transition: background-color 0.2s ease-in-out;
      color: var(--light-blue);
    }
  }

  h2 {
    font-size: var(--size-h2);
    line-height: 48px;
    color: var(--secundary-black);
    font-weight: 700;

    span {
      font-weight: 400;
      line-height: 32px;
    }
  }

  .news {
    padding: 48px 0 98px;
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    margin: 100px 0;
    text-align: center;
    padding-top: 100px;

    p {
      max-width: 310px;
      margin: 0 auto;
    }

    img {
      margin-bottom: 29px;
    }
  }

  .search {
    margin: 48px 0 36px;
    background: var(--grey-custom);
    max-width: 324px;
    width: 100%;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 0 23px;
    height: 50px;
    position: relative;

    img {
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    input {
      height: 24px;
      border: none;
      background: none;
      box-shadow: none;
      font-size: var(--size-button);
      font-weight: var(--weight-light);
      color: var(--grey-dark-custom);
      width: 100%;
      max-width: 240px;
      padding-right: 30px;
    }
    .button-primary {
      width: 50px;
      position: absolute;
      right: -20px;
      min-width: inherit;

      img {
        margin: 0 0 0 0px;
      }
    }
  }

  .box-news {
    max-width: 380px;
    width: 100%;

    img {
      width: 100%;
      height: auto;
      margin-bottom: 30px;
      border-radius: 30px;
      height: 254px;
      object-fit: cover;
    }

    h3 {
      margin-bottom: 16px;
      font-weight: 700;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--atomic);
    }

    p {
      font-weight: 300;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--atomic);
      margin-bottom: 32px;
      min-height: 70px;
    }

    a {
      text-decoration: none;
    }

    .button {
      text-decoration: none;
      color: var(--white);
      background-color: var(--blue-custom);
      font-weight: 700;
      border-radius: 10px;
      padding: 12px;
      font-size: var(--size-button);
    }

    .button:hover,
    .button:active,
    .button:focus {
      transition: background-color 0.2s ease-in-out;
      background-color: var(--light-blue);
    }
  }

  .other-news {
    padding: 48px 0;

    .container-news {
      flex-direction: column;
    }

    .box-news {
      max-width: 100%;
      padding: 24px 24px 24px 48px;
      border: 2px solid var(--grey-custom);
      border-radius: 40px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      img {
        max-width: 302px;
        margin: 0;
        height: 200px;
      }

      .news-content {
        max-width: 750px;
      }
    }
  }

  .hero-blog {
    width: 1200px;
    min-height: 610px;
    display: flex;
    background-size: cover;
    background-position: center;
    position: relative;
    margin: 0 auto;
    border-radius: 30px;

    .hero-mask {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 30px;
    }

    .container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      max-width: 1020px;
      position: relative;
      text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.2);

      h1 {
        max-width: 619px;
        color: var(--white);
        line-height: 60px;
        font-size: calc(var(--size-h1) - 22px);
        padding: 0 0 24px;
        font-weight: 700;
        font-family: var(--font-primary);
      }

      p {
        font-size: var(--size-large);
        max-width: 600px;
        line-height: 29px;
        font-family: var(--font-primary);
        font-weight: 300;
        color: var(--white);
        margin: 0 0 24px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 0 0 20px;
    margin-top: 0;

    .hero-blog {
      width: 100%;
      min-height: 580px;

      .hero-mask {
        border-radius: 34px;
      }

      .container {
        h1 {
          font-size: calc(var(--size-large) + 7px);
          line-height: 36px;
          margin: 0 0 16px;
        }
        p {
          font-size: 16px;
        }
      }
    }

    .news {
      padding: 40px 0;

      .container {
        align-items: flex-start;
        flex-direction: column;

        &.container-news {
          margin-top: 32px;
        }
      }

      .box-news {
        margin-bottom: 32px;

        &:last-child {
          margin-bottom: 0px;
        }

        p {
          margin-bottom: 16px;
        }
      }
    }

    .other-news {
      padding: 0 0 40px;

      .container {
        &.container-news {
          margin-top: 32px;
        }
      }

      .box-news {
        flex-direction: column;
        border-radius: 10px;
        padding: 16px;

        img {
          margin: 0 0 16px;
        }
      }
    }
  }
}
</style>
